class FreeShippingMeter extends HTMLElement {
    constructor() {
        super();
    }

    static freeShippingText = window.free_shipping_text.free_shipping_message;
    static freeShippingText1 = window.free_shipping_text.free_shipping_message_1;
    static freeShippingText2 = window.free_shipping_text.free_shipping_message_2;
    static freeShippingText3 = window.free_shipping_text.free_shipping_message_3;
    static freeShippingText4 = window.free_shipping_text.free_shipping_message_4;
    static classLabel1 = 'progress-30';
    static classLabel2 = 'progress-60';
    static classLabel3 = 'progress-100';
    static freeshipPrice = Number(window.free_shipping_price);

    connectedCallback() {
        this.freeShippingEligible = 0;
        this.progressBar = this.querySelector('[data-shipping-progress]');
        this.messageElement = this.querySelector('[data-shipping-message]');
        this.textEnabled = this.progressBar?.dataset.textEnabled === 'true';
        this.shipVal = window.free_shipping_text.free_shipping_1;
        this.progressMeter = this.querySelector('[ data-free-shipping-progress-meter]');

        this.handleCartChange = () => this.queueRefresh();
        this.addEventListener('change', this.handleCartChange);
        this.cartEvents = ['cart-update', 'cart:updated', 'cart:refresh'];
        this.cartEvents.forEach(name => document.addEventListener(name, this.handleCartChange));
        this.totalSelector = '[data-cart-total-value], [data-cart-subtotal], .cart-total-subtotal, .cart-total-grandtotal';
        this.cartObserver = new MutationObserver(records => {
            const relevant = records.some(record => {
                const target = record.target.nodeType === 1 ? record.target : record.target.parentElement;
                if (!target || this.contains(target)) return false;
                if (target.closest(this.totalSelector)) return true;
                return Array.from(record.addedNodes).some(node => node.nodeType === 1 &&
                    (node.matches(this.totalSelector) || node.querySelector(this.totalSelector)));
            });
            if (relevant) this.queueRefresh();
        });
        this.cartObserver.observe(document.body, {
            childList: true, subtree: true, characterData: true,
            attributes: true, attributeFilter: ['data-cart-total-value']
        });
        this.wasOpen = document.body.classList.contains('cart-sidebar-show');
        this.openObserver = new MutationObserver(() => {
            const isOpen = document.body.classList.contains('cart-sidebar-show');
            if (isOpen && !this.wasOpen) this.queueRefresh();
            this.wasOpen = isOpen;
        });
        this.openObserver.observe(document.body, {attributes: true, attributeFilter: ['class']});

        this.initialize();
    }

    disconnectedCallback() {
        this.removeEventListener('change', this.handleCartChange);
        (this.cartEvents || []).forEach(name => document.removeEventListener(name, this.handleCartChange));
        this.cartObserver?.disconnect();
        this.openObserver?.disconnect();
        clearTimeout(this.refreshTimer);
        clearTimeout(this.renderTimer);
        this.requestId = (this.requestId || 0) + 1;
        this.cartRequest?.abort();
    }

    queueRefresh() {
        // Invalidate pending responses as soon as a newer cart change is observed.
        this.requestId = (this.requestId || 0) + 1;
        this.cartRequest?.abort();
        clearTimeout(this.renderTimer);
        clearTimeout(this.refreshTimer);
        this.refreshTimer = setTimeout(() => this.initialize(), 120);
    }

    async initialize() {
        const requestId = this.requestId = (this.requestId || 0) + 1;
        this.cartRequest?.abort();
        this.cartRequest = new AbortController();
        const root = (window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
        try {
            const response = await fetch(root + 'cart.js?_tl_shipping=' + Date.now(), {
                credentials: 'same-origin', cache: 'no-store', signal: this.cartRequest.signal
            });
            if (!response.ok) throw new Error('Cart could not be loaded');
            const cart = await response.json();
            if (!this.isConnected || requestId !== this.requestId) return;
            this.cart = cart;
            this.calculateProgress(cart);
        } catch (error) {
            if (error.name !== 'AbortError' && requestId === this.requestId && this.isConnected) {
                // Hide an unverified remaining amount instead of showing a stale claim.
                if (this.progressBar) this.progressBar.style.display = 'none';
                if (this.messageElement) this.messageElement.textContent = '';
            }
        }
    }

    calculateProgress(cart) {
        clearTimeout(this.renderTimer);
        this.freeShippingEligible = 0;
        const subscriptionCart = (cart.items || []).some(item => item.selling_plan_allocation);
        this.subscriptionCart = subscriptionCart;
        if (subscriptionCart) {
            if (this.progressBar) this.progressBar.style.display = 'none';
            if (this.messageElement) this.messageElement.textContent = 'Free shipping on subscription orders.';
            return;
        }
        if (this.progressBar) this.progressBar.style.display = '';

        const cartTotalPrice = parseInt(cart.total_price) / 100;
        let freeShipBar = Math.round((cartTotalPrice * 100) / FreeShippingMeter.freeshipPrice);
        if (freeShipBar >= 100) {
            freeShipBar = 100;
        }
        
        const text = this.getText(cartTotalPrice, freeShipBar);
        const classLabel = this.getClassLabel(freeShipBar);

        this.setProgressWidthAndText(freeShipBar, text, classLabel);
    }

    getText(cartTotalPrice, freeShipBar) {
        let text;

        if (cartTotalPrice == 0) {
            this.progressBar.classList.add('progress-hidden');
            text = '<span>' + FreeShippingMeter.freeShippingText + ' ' + Shopify.formatMoney(FreeShippingMeter.freeshipPrice * 100, window.money_format) +'!</span>';
        } else if (cartTotalPrice >= FreeShippingMeter.freeshipPrice) {
            this.progressBar.classList.remove('progress-hidden');
            this.freeShippingEligible = 1;
            text = FreeShippingMeter.freeShippingText1;
        } else {
            this.progressBar.classList.remove('progress-hidden');
            const remainingPrice = Math.max(0, Math.round((FreeShippingMeter.freeshipPrice - cartTotalPrice) * 100)) / 100;
            text = '<span>' + FreeShippingMeter.freeShippingText2 + ' </span>' + Shopify.formatMoney(remainingPrice * 100, window.money_format) + '<span> ' +  FreeShippingMeter.freeShippingText3 + ' </span><span class="text">' + FreeShippingMeter.freeShippingText4 + '</span>';
            this.shipVal = window.free_shipping_text.free_shipping_2;
        }

        return text;
    }

    getClassLabel(freeShipBar) {
        let classLabel;

        if (freeShipBar === 0) {
            classLabel = 'none';
        } else if (freeShipBar <= 30) {
            classLabel = FreeShippingMeter.classLabel1;
        } else  if (freeShipBar <= 60) {
            classLabel = FreeShippingMeter.classLabel2;
        } else if (freeShipBar < 100) {
            classLabel = FreeShippingMeter.classLabel3;
        } else {
            classLabel = 'progress-free'
        }

        return classLabel;
    }
    
    resetProgressClass(classLabel) {
        this.progressBar.classList.remove('progress-30');
        this.progressBar.classList.remove('progress-60');
        this.progressBar.classList.remove('progress-100');
        this.progressBar.classList.remove('progress-free');

        this.progressBar.classList.add(classLabel);
    }
    
    setProgressWidthAndText(freeShipBar, text, classLabel) {
        clearTimeout(this.renderTimer);
        this.renderTimer = setTimeout(() => {
            if (this.subscriptionCart) return;
            this.resetProgressClass(classLabel);

            this.progressMeter.style.width = `${freeShipBar}%`;
            if (this.textEnabled) {
                const textWrapper = this.progressMeter.querySelector('.text');
                if (textWrapper) textWrapper.textContent = `${freeShipBar}%`;
            }

            this.messageElement.innerHTML = text;

            if ((window.show_multiple_currencies && typeof Currency != 'undefined' && Currency.currentCurrency != shopCurrency) || window.show_auto_currency) {
                Currency.convertAll(window.shop_currency, $('#currencies .active').attr('data-currency'), 'span.money', 'money_format');
            }
        }, 400)
    }
}

if (!customElements.get('free-shipping-component')) {
    customElements.define('free-shipping-component', FreeShippingMeter);
}